import http from 'util/http'

/** 获取分类列表 */
export function getNavCategoryList() {
  return http.get('/newxyrj/public/navigation/category/list', {})
}
/**
 * 根据分类id获取数据
 * @param {number} id 分类id
 * @param {object} param0 分页
 * @param {number} param0.pageindex 页码
 * @param {number} param0.pagesize 数量
 */
export function getCategoryList(
  id: number,
  {
    pageindex,
    pagesize = 10,
  }: {
    pageindex: number
    pagesize?: number
  },
) {
  return http.get('/newxyrj/public/navigation/category/data', {
    category_id: id,
    pageindex,
    pagesize,
  })
}
/**
 * 个性推荐
 * @param {object} param0 分页
 * @param {number} param0.pageindex 页码
 * @param {number} param0.pagesize 数量
 */
export function getPersonalList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.get('/newxyrj/public/article/recommand/personal', {
    pageindex,
    pagesize,
  })
}
/**
 * 热门
 * @param {object} param0 分页
 * @param {number} param0.pageindex 每页返回的行数
 * @param {number} param0.pagesize 分页起始索引
 */
export function getHotList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.get('/newxyrj/public/article/hot/list', {
    pageindex,
    pagesize,
  })
}
/**
 * 权限推荐
 * @param {object} param0 分页
 * @param {number} param0.pageindex 每页返回的行数
 * @param {number} param0.pagesize 分页起始索引
 */
export function getPermList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.get('/newxyrj/public/article/recommand/permission', {
    pageindex,
    pagesize,
  })
}

/**
 * 最新课程
 */
export function getNewCourse() {
  return http.get('/newxyrj/public/article/new/list', {})
}

/**
 * 首页轮播图
 * @param {number} position_id 广告id
 */
export async function getBannerList(params: { position_id: number }) {
  return http.get('user-portrait/api/v1/pd/list', params, {
    baseUrl: '//gw.n8n8.cn',
    structure: 'data',
  })
}
